module.exports = __webpack_public_path__ + "files/6ae7204950b9ea47e9a513c435176ccd.png";